import { FC } from 'react';
import { ConfirmDialog, customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { useDeleteAccessToken } from '../../hooks';
import { AccessToken, SafeAccessToken } from '@agilelab/plugin-wb-auth-backend';
import { useApi } from '@backstage/core-plugin-api';

type DeleteAccessTokenDialogProps = {
  token: AccessToken | SafeAccessToken | null;
  onClose: () => void;
  onDeleted?: () => void;
};

export const DeleteAccessTokenDialog: FC<DeleteAccessTokenDialogProps> = ({
  token,
  onClose,
  onDeleted,
}) => {
  const alertApi = useApi(customAlertApiRef);
  const { isLoading: deleting, mutate: deleteFn } = useDeleteAccessToken();

  return (
    <ConfirmDialog
      inProgress={deleting}
      open={Boolean(token)}
      onClick={e => e.stopPropagation()}
      onClose={onClose}
      title="Permanently delete the access token?"
      description="The token will be deleted and can no longer be used.
This action cannot be undone."
      confirmButtonText="Delete"
      onConfirm={() => {
        if (!token) return;
        deleteFn(
          { uuid: token.uuid },
          {
            onSuccess: () => {
              onDeleted?.();
              alertApi.post({
                severity: 'info',
                message: 'Access token deleted successfully',
              });
              onClose();
            },
            onError: () => {
              onClose();
            },
          },
        );
      }}
    />
  );
};
